import styled from "styled-components";
import { Button } from "reactstrap";


export const Container = styled.div`
    width:100%;
    height:100vh;
    display:flex;
    justify-content:center;
    align-items:center;
`;

export const MainContainer = styled.div`
    height:100%;
    width:90%;
    display:grid;
    grid-template-columns: ${(props) => props.qr !== false ? '2fr 1fr' : '1fr 1fr'};
    justify-content:center;
    
    .full-width{
        display:flex;
        flex-direction:column;
        align-items:center;
        width:100%;
   
    }

    .postulation-complete{
        display:flex;
        flex-direction:column;
        align-items:center;
        width:100%;
        margin-top: 50px;
    }

    @media screen and (max-width:1250px){
        width:100%;
    }

    @media (max-width:850px){
        grid-template-columns: 1fr;
        .order-two{
            display:none;        
        }
        .order-one{
            padding:30px;        
        }
    } 
`;


export const ContainerInformation = styled.div`
    width:80%;
    @media (max-width:750px){
        width:100%;
    } 
`;

export const ContainerFormulario = styled.div`
    position:relative;
    width:80%
    padding-top: 8%;
    background-color: #F2F2F2;
    margin-top:50px;

    .rmd-form-message{
         margin-bottom: 0 !important;
    }

    .container {
        width:100% !important;
        display: flex;
        flex-direction: column;
        item-align: center;
        justify-content: center;
        text-align: left;
    }

    input, select{
        background:white;
    }

    .container-inputs-flex{
        display: grid;
        grid-template-columns: repeat(2,1fr);
        gap:10px;
        width:100%;
        item-align: center;
        justify-content: center;
        text-align: left;
    }

    .btn-iniciar{
        height: 70px ;
        display:flex;
        justify-content: center ;
        align-items: center;
    }

    .close-icon{
        display:none;
        justify-content:center;
        text-align: center;
        position: absolute;
        width: 30px;
        top: 0;
        right: 0;
        color: red;
        font-size: 20px;
        font-weight: bold;
        background: #F2F2F2;
        border-radius: 50px;
        isolation: isolate;
        :hover{
            cursor:pointer;
        }
    }

    @media (max-width:480px){
        .container-inputs-flex{
            display: flex;
            flex-direction: column;
            width:100%;
        }        
    }

    @media (max-width:850px){
        width:90%;
    } 

    .file-input{
        display:flex;
        align-items:center;
        justify-content:center;

        .button-delete {
            margin-left:10px;
            background-color: #dc3545;
            color: #fff; 
            
            border: none;
            border-radius: 100vmax;
            cursor: pointer; 
            font-size: 10px;
            width: 30px;
            height: 30px;
          }
          
          
          .button-delete:hover {
            background-color: #c82333; 
          }
    }

`;


export const HeadInformation = styled.div`
    margin:20px 0;
`;

export const LoadContainer = styled.div`
    display: flex;
    margin: 50px 0px;
    width: 100%;
    place-content: center;
`;

export const ButtonPostulation = styled(Button)`
    background-color: #f5a796!important;
    border: 1px solid #d3d3d3!important;
    min-width:200px;
`;

export const ButtonContainer = styled.div`
    display:none;
    place-content: center;
    text-align:center;
    width:100%;

    @media (max-width:850px){
        display:flex;
    }  
`;

export const ButtonContainerNormal = styled.div`
    display:flex;
    place-content: center;
    text-align:center;
    width:100%;

    @media (max-width:850px){
        display:none;
    }  
`;
export const ButtonPostularNormal = styled.button`
    margin-top: 10rem;
    height:35px;
    padding:5px;
    background-color: #f5a796!important;
    border: 1px solid #d3d3d3!important;
    border-radius:10px;
    font-size:16px;
    font-weight:bold;
    color:white;
    min-width:200px; 
    bottom:10px;  
`;

export const ButtonPostular = styled.button`
    position:fixed;
    padding:5px;
    background-color: #f5a796!important;
    border: 1px solid #d3d3d3!important;
    border-radius:10px;
    font-size:16px;
    font-weight:bold;
    color:white;
    min-width:200px; 
    bottom:10px;  
`;
